(() => {
  function $(sel) {
    return document.querySelector(sel);
  }

  function getStandVariantId() {
    const el = $('#addon-stand-variant-id');
    return el ? el.value.trim() : null;
  }

  function isStandChecked() {
    const cb = $('#addon-stand-checkbox');
    return !!(cb && cb.checked);
  }

  function getMainQuantity(form) {
    const qty = form.querySelector('input[name="quantity"]');
    const val = qty ? Number(qty.value) : 1;
    return Number.isFinite(val) && val > 0 ? val : 1;
  }

  // ✅ This is the key: refresh the cart drawer + cart bubble HTML
  async function refreshCartUI() {
    try {
      const res = await fetch('/?sections=cart-drawer,cart-icon-bubble', {
        headers: { Accept: 'application/json' }
      });
      const sections = await res.json();

      // Update cart icon bubble (top right cart count)
      const bubbleHTML = sections['cart-icon-bubble'];
      if (bubbleHTML) {
        const bubbleContainer = document.createElement('div');
        bubbleContainer.innerHTML = bubbleHTML;
        const newBubble = bubbleContainer.querySelector('#cart-icon-bubble');
        const oldBubble = document.querySelector('#cart-icon-bubble');
        if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);
      }

      // Update cart drawer content
      const drawerHTML = sections['cart-drawer'];
      if (drawerHTML) {
        const drawerContainer = document.createElement('div');
        drawerContainer.innerHTML = drawerHTML;

        // Dawn/Craft drawer usually contains #CartDrawer
        const newDrawer = drawerContainer.querySelector('#CartDrawer');
        const oldDrawer = document.querySelector('#CartDrawer');
        if (newDrawer && oldDrawer) oldDrawer.replaceWith(newDrawer);
      }
    } catch (e) {
      console.warn('Cart UI refresh failed', e);
    }
  }

  async function addStandToCart(standVariantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(standVariantId), quantity }]
      })
    });

    if (!res.ok) {
      const text = await res.text();
      console.warn('❌ Could not add stand. Response:', text);
      alert('Could not add the wooden display stand automatically. Please add it manually, or contact us.');
      return false;
    }

    // ✅ Refresh cart drawer so it shows immediately
    await refreshCartUI();
    return true;
  }

  function findMainProductForm() {
    // Craft/Dawn uses <product-form>. This targets the real add-to-cart form.
    const pf = $('product-form form[action^="/cart/add"]');
    if (pf) return pf;

    // Fallback: any cart/add form that is NOT the Shop Pay installment form
    const forms = document.querySelectorAll('form[action^="/cart/add"]');
    for (const f of forms) {
      if (f.classList.contains('installment')) continue;
      if (f.querySelector('input[name="quantity"]') || f.querySelector('button[name="add"]')) return f;
    }
    return null;
  }

  function attach() {
    const form = findMainProductForm();
    if (!form) {
      console.warn('❌ Could not find main product form.');
      return;
    }

    form.addEventListener(
      'submit',
      () => {
        const standVariantId = getStandVariantId();
        if (!standVariantId) return;
        if (!isStandChecked()) return;

        const qty = getMainQuantity(form);

        // Wait briefly so the main product adds first
        setTimeout(() => addStandToCart(standVariantId, qty), 700);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
